import { render, staticRenderFns } from "./CreateKeyModal.vue?vue&type=template&id=060fde3e"
import script from "./CreateKeyModal.vue?vue&type=script&lang=js"
export * from "./CreateKeyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports